class IronlineLocalInstall extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.toggle = this.querySelector('[data-local-install-toggle]');
    this.details = this.querySelector('[data-local-install-details]');
    this.dateInput = this.querySelector('[data-local-install-date]');
    this.dialog = this.querySelector('[data-local-install-dialog]');
    this.purchase = this.closest('ironline-setup-purchase');
    this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
    if (!this.toggle) return;
    if (new URLSearchParams(window.location.search).get('local_install') === 'shop') this.toggle.checked = true;
    if (this.dateInput) {
      const today = new Date();
      this.dateInput.min = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    }
    this.addEventListener('change', () => { this.sync(); this.purchase?.sync?.(); }, { signal });
    this.querySelector('[data-install-review]')?.addEventListener('click', () => this.guardCart(), { signal });
    this.querySelectorAll('[data-install-close]').forEach(button => button.addEventListener('click', () => this.dialog?.close(), { signal }));
    this.dialog?.addEventListener('close', () => this.returnFocus?.focus({ preventScroll: true }), { signal });
    this.dialog?.addEventListener('click', event => {
      if (event.target !== this.dialog) return;
      const box = this.dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
    }, { signal });
    this.sync();
    customElements.whenDefined('ironline-setup-purchase').then(() => { if (this.isConnected) this.purchase?.sync?.(); });
  }
  disconnectedCallback() { this.controller?.abort(); }
  sync() {
    if (!this.toggle) return;
    const selected = this.toggle.checked;
    this.details.hidden = !selected;
    this.toggle.setAttribute('aria-expanded', String(selected));
    this.classList.toggle('is-selected', selected);
    if (this.dateInput) this.dateInput.disabled = !selected;
    const acknowledgement = this.closest('form')?.querySelector('[data-purchase-ack]');
    const acknowledgementLabel = acknowledgement?.querySelector('.checkbox__label-text');
    const acknowledgementInput = acknowledgement?.querySelector('input');
    if (acknowledgementLabel && acknowledgementInput && this.dataset.acknowledgement) {
      acknowledgementLabel.dataset.installDefaultLabel ||= acknowledgementLabel.textContent;
      const label = selected ? this.dataset.acknowledgement : acknowledgementLabel.dataset.installDefaultLabel;
      if (acknowledgementLabel.textContent !== label) {
        acknowledgementLabel.textContent = label;
        acknowledgementInput.checked = false;
      }
    }
  }
  updateTotals(unitTotal, quantity) {
    this.totalCents = unitTotal * quantity;
    this.laborCents = Number(this.toggle?.dataset.price || 0) * quantity;
    this.quantity = quantity;
    const total = this.querySelector('[data-local-installed-total]');
    if (total) total.textContent = this.money.format(this.totalCents / 100);
  }
  guardCart() {
    if (!this.toggle?.checked) return true;
    const variantId = Number(this.toggle.dataset.variantId);
    if (this.dataset.preview === 'false' && this.dataset.ready === 'true' && Number.isSafeInteger(variantId) && variantId > 0) return true;
    this.purchase?.sync?.();
    this.returnFocus = document.activeElement;
    this.querySelector('[data-install-review-package]').textContent = this.money.format(((this.totalCents || 0) - (this.laborCents || 0)) / 100);
    this.querySelector('[data-install-review-labor]').textContent = this.money.format((this.laborCents || 0) / 100);
    this.querySelector('[data-install-review-total]').textContent = this.money.format((this.totalCents || 0) / 100);
    if (this.dialog && !this.dialog.open) this.dialog.showModal();
    return false;
  }
}
if (!customElements.get('ironline-local-install')) customElements.define('ironline-local-install', IronlineLocalInstall);
